import { render, staticRenderFns } from "./InfinityTree.vue?vue&type=template&id=47c85c56&scoped=true"
import script from "./InfinityTree.vue?vue&type=script&lang=ts"
export * from "./InfinityTree.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c85c56",
  null
  
)

export default component.exports